// AUTOGENERATED (TS) — do not edit. Source: schemas/ml_defaults.json. Run `bun run codegen/generate.ts` to regenerate.
// The ONE global training-hyperparameter default, shared by every mode on
// every platform — see docs/specs/recon/simplification-audit-2026-07.md S26.
// Consumed by WasmIML's train()/trainAsync() default parameters and
// EngineApi's learningRate/maxIterations options (manifold/src/engine/).

export interface MlTrainDefaults {
  readonly learningRate: number;
  readonly maxIterations: number;
  readonly minError: number;
}

export const ML_TRAIN_DEFAULTS: MlTrainDefaults = {
  learningRate: 1,
  maxIterations: 1000,
  minError: 0.001,
};
